<template>
    <div>
        <template v-if="visible">
            <a-range-picker v-model="pickerData" :defaultValue="[moment(), moment()]" :showTime="true" @ok="change" />
        </template>
        <template v-else>
            <slot>
                <span v-if="startTime">
                    {{ moment(startTime * 1000).format('lll') }}
                </span>
                <span v-if="endTime">
                    至
                    {{ moment(endTime * 1000).format('lll') }}
                </span>
            </slot>
            <a-button icon="edit" type="link" @click="edit" />
        </template>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        startTime: Number,
        endTime: Number
    },
    data() {
        return {
            visible: false,
            pickerData: [],
        };
    },
    mounted() {
    },
    methods: {
        edit() {
            this.visible = true;
        },
        change(range) {
            console.info(range);
            this.visible = false;
            this.$emit("change", range);
        },
        moment
    }
};
</script>